import $ from 'jquery';
import urls from 'core/urls';
import datatable from 'components/datatable';
import selectize_util from "root/static/js/components/selectize";
import moment from 'moment';
import autosize from 'autosize';
import 'bootstrap-confirmation2';
import anim from "root/static/js/core/loading-animation";
import DD from 'components/dropdown';
import browser_storage from 'core/browser-storage';
import FakeProgress from 'components/fake-progress';
import utilities from 'core/utilities';
import modal from 'components/modal';
import requestTM from 'components/request-time-manager';

const TICKET_ID_REGEX = new RegExp('^' + urls['csat:reviews'](0).replace(/0/, '([^/]+)') + '$');

let dataTimeManager = new requestTM();

let filterData = {
    "ratings": [],
    "companies": [],
    "agents": [],
    "segments": [],
    "statuses": [],
    "tags": [],
    "comments": "all",
};

let filtersProgress = new FakeProgress(
    document.querySelector(".filter-settings .loader-bar")
);

let resyncButton = document.querySelector('#reaction-details-button-resync-ticket');
let resyncText = document.querySelector('#reaction-details-button-resync-ticket .resync-copy');
let resyncMessaging = document.querySelector(".resync-messaging");

let startDate = browser_storage.getItem("csat-filters-start_date") || moment().subtract(90, 'days');
let endDate = browser_storage.getItem("csat-filters-end_date") || moment();

filterData.start_date = moment(startDate).format("YYYY-MM-DD");
filterData.end_date = moment(endDate).format("YYYY-MM-DD");

let columns = [];
let columnConfig;

let modalNodes = {
    modal: document.querySelector(".modal_js"),
    close: document.querySelector(".modal-close_js"),
    content: document.querySelector(".modal-content_js"),
    title: document.querySelector(".modal-title_js"),
    bg: document.querySelector(".modal-bg_js"),
    blur: [
        document.querySelector(".content-wrap"),
        document.querySelector(".sidebar-nav"),
        document.querySelector(".navigation-top")
    ]
}

let createdModal = modal.create(modalNodes, function () {});

let tssType = document.querySelector("header.main").dataset.platform;

class ReviewsTable {
    constructor (root, anim, getFilters, onUpdate=null) {
        window.table = this;
        this.root = $(root);
        this.reactionDialog = $('#show-reaction-details');
        this.reactionDetailsTagsWidget = selectize_util.optionalInstance($('#reaction-details-tags'));
        this.reactionDetailsAgentsWidget = selectize_util.optionalInstance($('#reactions-details-agents-edit'));

        this.isCsatAdmin = this.root.data('is_csat_admin') === "True";

        let reviewFields = JSON.parse(document.querySelector("#reviewFields").innerText);

        columnConfig = {
            sentiment: {
                title: 'Rating',
                width: '56px',
                className: 'column-sentiment',
                data: 'sentiment',
                render: {
                    _: function(data) {
                        return globals.getSentimentLabel(data);
                    },
                    display: function(data) {
                        var sentiment_image = '<div class="image-wrapper"><img src="' + globals.getSentimentImageUrl(data) + '" alt="' + globals.getSentimentLabel(data) + '" height="30" width="30"/></div>';
                        return sentiment_image;
                    },
                    sort: null
                },
                position: 0,
            },
            timestamp: {
                title: 'Date',
                width: '8%',
                className: 'column-date',
                data: 'timestamp',
                render: {
                    _: 'formatted',
                    sort: 'iso8601',
                    exportPrint: 'formatted',
                    exportTabular: function(data) {return moment(data.iso8601).format('YYYY-MM-DD HH:mm:ss');},
                    display: function(data) {return moment(data.iso8601).format('DD MMM YYYY');}
                },
                position: 1,
            },
            ticket: {
                title: 'Ticket',
                className: 'column-ticket',
                data: 'ticket',
                width: '15%',
                render: {
                    _: 'id',
                    display: function(data) {
                        if(tssType === 'sc') {
                            return data.link != null ? `<a target="_blank" href="${data.link}">${data.title}</a>` : `${data.title}`;
                        }
                        return data.link != null ? `<a target="_blank" href="${data.link}">${data.id}</a><br>${data.title}` : `${data.id}<br>${data.title}`;
                    },
                },
                position: 2,
            },
            company: {
                title: 'Company',
                className: 'column-company',
                width: '100px',
                data: 'company',
                render: {
                    _: 'name',
                    display: function(data) {return (data.link !== null && data.link !== "" ) ? '<a target="_blank" href="' + data.link + '">' + data.name + '</a>' : data.name;}
                }
            },
            contact: {
                title: 'Contact',
                className: 'column-contact',
                data: 'contact',
                width: '90px',
                render: {
                    _: 'name',
                    display: function(data) {return data.link != null ? '<a target="_blank" href="' + data.link + '">' + data.name + '</a>' : data.name;}
                }
            },
            agents: {
                title: 'Agents',
                className: 'column-agents',
                data: 'agents',
                width: '90px',
                render: {
                    _: null,
                    display: function(data) {
                        return typeof data === 'string' ? data : data.join(", ");
                    }
                }
            },
            segment: {
                title: 'Boards',
                className: 'column-segment',
                data: 'segment',
                width: '69px',
            },
            widget_publicize: {
                title: 'Publish Comment',
                    width: '74px',
                className: 'column-publish',
                data: 'widget_publicize',
                render: {
                    display: (data, type, full, meta) => {
                        let disableIfInactive = window.table.root.data('is-active') === 'True' ? '' : 'disabled';
                        let publishTooltip = full.comment ? "<div class='tooltip'>Marketing permission not provided</div>" : "<div class='tooltip no-comment'>Comment not provided</div>";
                        if (full.publicize) {
                            return `<div class="mini-toggle">
                                        <input 
                                            type="checkbox" 
                                            id="review-${full.ticket.id}" 
                                            class="permissions-toggle ${this.isCsatAdmin ? '' : 'disabled'} ${disableIfInactive}" 
                                            data-ticket-id='${full.ticket.id}' 
                                            onclick='window.table.togglePublish(event)' 
                                            ${data ? 'checked' : ''}>
                                        </input>
                                        <label for="review-${full.ticket.id}"></label>
                                    </div>`;
                        } else {
                            return `–${publishTooltip}`;
                        }
                    }
                }
            },
            row_id: {
                title: '',
                className: 'column-action',
                data: "row_id",
                orderable: false,
                render: {
                    display: function(data) {
                        let disableIfInactive = window.table.root.data('is-active') === 'True' ? '' : 'disabled';
                        return `<div data-id="${data}" class='${disableIfInactive} view-details button-secondary'>More</div>`
                    },
                }
            },
            comment: {
                title: 'Comment',
                visible: false,
                data: 'comment'
            },
            status: {
                title: 'Status',
                visible: false,
                data: 'status'
            },
            tags: {
                title: 'Tags',
                visible: false,
                data: 'tags'
            },
            session: {
                title: 'Session',
                data: 'session'
            },
            groups: {
                title: 'Groups',
                visible: false,
                data: 'groups'
            },
        };

        // add only required columns to table
        reviewFields.forEach(field => {
            if(columnConfig[field.id]) {
                if(field.display_name) {
                    columnConfig[field.id].title = field.display_name;
                }
                columns.push(columnConfig[field.id]);
            }
        })

        // sort columns array according to columnConfig order
        columns.sort((a, b) => Object.keys(columnConfig).indexOf(a.data) - Object.keys(columnConfig).indexOf(b.data));

        this.reactions = datatable.create(root, {
            language: {
                emptyTable: 'No reviews yet',
                zeroRecords: 'No results found with current filters.',
                infoFiltered: '',
                searchPlaceholder: "Search",
                search: "",
                lengthMenu: `Results per page: 
                            <div class='custom-select thin limit-selector'>
                            _MENU_
                            <img src="/static/icons/select-arrow.svg" alt="">
                            </div>`,
                paginate: {
                    previous: "Prev",
                    next: "Next",
                },  
            },
            columns: columns,
            rowId: 'row_id',
            order: [[1, 'desc']],
            ajax: {
                url: urls['csat:review-data'](),
                contentType: "application/json",
                type: "POST",
                data: (d) => {
                    filtersProgress.node.classList.remove("disabled");
                    filtersProgress.startLoading(10);
                    d.filters = filterData;
                    return JSON.stringify(d);
                },
                dataSrc: (d) => {
                    filtersProgress.loadFinish();
                    filtersProgress.node.classList.add("disabled");
                    onUpdate({'metrics': d.metrics, 'benchmarks': d.benchmarks});
                    return d.reactions;
                }
            },
            lengthMenu: [ 10, 25, 50, 100],
            serverSide: true,
            createdRow: this.createRowCallback.bind(this),
            initComplete: () => {
                let ticketId = this.getTicketId();
                if(ticketId) {
                    let data = {
                         'agents': this.reactionDialog.data('agents'),
                         'groups': this.reactionDialog.data('groups'),
                         'comment': this.reactionDialog.data('comment'),
                         'company': this.reactionDialog.data('company'),
                         'contact': this.reactionDialog.data('contact'),
                         'labels': this.reactionDialog.data('labels'),
                         'publicize': this.reactionDialog.data('publicize'),
                         'segment': this.reactionDialog.data('segment'),
                         'sentiment': this.reactionDialog.data('sentiment'),
                         'status': this.reactionDialog.data('status'),
                         'tags': this.reactionDialog.data('tags'),
                         'ticket': this.reactionDialog.data('ticket'),
                         'timestamp': this.reactionDialog.data('timestamp'),
                         'widget_publicize': this.reactionDialog.data('widget_publicize')
                    };
                    
                    this.populateReactionDetailsDialog(data);
                    this.loadActivityStream(data.ticket.id, false);
                    this.togglereactionDialog('show');
                }

                let limitSelector = document.querySelector("#reactions_length .limit-selector")
                DD(limitSelector, (val) => {
                    window.table.reactions.page.len(val).draw();
                })

                this.resizeHandler();

                //add icon to search filter bar
                let imageHtml = document.createElement("IMG");
                imageHtml.src = "/static/icons/ic-search.svg";
                let searchBar = document.querySelector("#reactions_filter");

                searchBar.append(imageHtml);


            },
            stateSave: false,
            dom: 'lfBr<"table-wrapper"t><"table-controls-bottom"p>',
            buttons: [               {
                    extend: 'csv',
                    className: 'button-secondary',
                    text: 'CSV <img src="/static/icons/csv_arrow.svg" alt="">',
                    action: (e, dt) => {
                        // $('#reactions-csv').modal();
                        var content = document.querySelector(".modal-template-csv_js");
                        var title = content.getAttribute("data-title");
                        var className = content.getAttribute("data-class");

                        createdModal.open({
                            //set a wrap class for a modal
                            class: className,
                            //set content for a modal
                            content: content.innerHTML,
                            //set title for a modal
                            title: title
                        }, function () {
                            //Bind events when DOM loaded at the modal screen;
                            $('.csat-csv-download_js').on('click', (e) => {
                                window.table.downloadCSV($(e.target).data('csv-type'));
                            }); 
                        });
                    },
                    init: (api, node) => {
                        $(node).removeClass('btn btn-secondary buttons-html5');
                    }
                }
            ]
        });
        $(root+'_filter input').unbind('input');
        $(root+'_filter input').unbind('keyup');
        $(root+'_filter input').bind('keyup', function(e) {
            if(e.keyCode == 13) {
                window.table.reactions.search( this.value ).draw();
            }
        });

        this.reactions.on('click', '.less-more', function(event) {
            event.preventDefault();

            let btn = $(event.target);
            if(btn.text() == 'more') {
                btn.parent().find('.csat-reaction-child-comment p').css('height', 'auto');
                btn.parent().find('.csat-reaction-child-comment p').css('white-space', 'normal');
                btn.text('less');
            } else {
                btn.parent().find('.csat-reaction-child-comment p').css('white-space', 'nowrap');
                btn.parent().find('.csat-reaction-child-comment p').css('height', 21);
                btn.text('more');
            }

        });
        window.addEventListener('resize', () => {
            this.resizeHandler();
        });

        this.reactions.on('click', '.view-details', function(event) {
            let rowId = $(this).attr('data-id');
            window.table.showReactionDetails(rowId);
            event.preventDefault();
            return false;
        });


        this.reactions.on('processing.dt',  (e, settings, processing) => {
            if(processing) {
                anim.start();
            }
        });
        this.reactions.on('draw.dt', anim.complete.bind(anim));


        // We want to show the entire 'row' with a different background on hover. However,
        // Datatables actually creates two HTML rows for each logical row, the second one being
        // called the 'child row' and containing comments and tags in our case.
        // As there's no CSS selector to match 'current and previous' element on hover (really,
        // there isn't! https://stackoverflow.com/q/1817792/6278), we need a JS solution.
        // What we're doing here is attaching an event handler to only the 'child rows' for
        // mouse enter/leave events and then we toggle a special 'hover' class on both HTML rows.
        this.reactions.on('mouseenter mouseleave', 'tr', function(event) {
            let rows;
            if($(this).attr('role')) {
                rows = $(this).next().addBack();
            } else {
                rows = $(this).prev().addBack();
            }

            if (event.type === 'mouseenter') {
                rows.addClass('hover');
            } else if (event.type === 'mouseleave') { 
                rows.removeClass('hover');
            }
        });


        // Unfortunately, we have to track whether we're currently handling a tab history event triggered by
        // the browser in a global variable. There doesn't seem to be another way to differentiate between
        // the Bootstrap event for 'user closed dialog' and the event that is triggered when we close the
        // dialog based on the user navigating through history.
        this.isCurrentlyPopstating = false;

        // When the user closes the dialog, create a new history entry. Unless we're already in the process of
        // handling a popstate browser event, in which case the browser has already updated the history for us.
        this.reactionDialog.on('hide.bs.modal', () => {
            if (!this.isCurrentlyPopstating) {
                window.history.pushState({}, '', urls['csat:reviews']());
                this.updateDocumentTitle();
            }
        });

        // When the user opens the dialog, create a new history entry. Unless we're already in the process of
        // handling a popstate browser event, in which case the browser has already updated the history for us.
        this.reactionDialog.on('show.bs.modal', () => {
            if (!this.isCurrentlyPopstating) {
                let relative_reaction_url = urls['csat:reviews'](this.reactionDialog.data('ticket_id'));
                window.history.pushState({}, '', relative_reaction_url);
                this.updateDocumentTitle(this.reactionDialog.data('ticket_id'));
            }
        });

        // When the user navigates through the tab history, update the dialog state accordingly.
        $(window).on('popstate', (evt) => {
            this.isCurrentlyPopstating = true;
            var ticketId = this.getTicketId();
            if (ticketId) {
                this.showReactionDetails('reaction_'+ticketId);
                this.updateDocumentTitle(ticketId);
            } else {
                this.togglereactionDialog('hide');
                this.updateDocumentTitle();
            }
            this.isCurrentlyPopstating = false;
        });

        $('.show-more-button').on('click', function(event) {
            $('.reactions-modal-activities').addClass('expanded');
            event.preventDefault();
        });
        $('.show-less-button').on('click', function(event) {
            $('.reactions-modal-activities').removeClass('expanded');
            event.preventDefault();
        });

        if(globals.user_authorization.csat_manager) {
            $('#reaction-details-button-done').on('click', () => {
                this.changeReactionStatus('done');
            });
            $('#reaction-details-button-open').on('click', () => {
                this.changeReactionStatus('open');
            });
            $('#reaction-details-tags').on('change', () => {
                this.validateTags();
            });
            $('#reaction-details-tags-save').on('click', (event) => {
                let ticket_id = this.reactionDialog.data('ticket_id');
                let tags = this.reactionDetailsTagsWidget.getValue() || [];

                // validate tags
                if (this.validateTags() === false) {
                    $('#reaction-details-tags-errorMessage').append("<span>Tags have not been saved!</span>");
                    return;
                }

                // report new status to the backend
                this.triggerAction(ticket_id, 'TAGS_CHANGED', {'tags': tags});

                // update status in the datatable
                let currentRow = this.getCurrentRow();
                currentRow.data().tags = tags;
                currentRow.invalidate();

                onUpdate({'tags':tags});

                // trigger the 'createdRow' callback again to update CSS classes and child node
                this.createRowCallback(currentRow.node(), currentRow.data(), currentRow.index());

                // redraw the table, which should rerun all filters and stats calculations
                this.reactions.draw('full-hold');

                // update the dialog
                this.populateReactionDetailsDialog(currentRow.data());

                event.preventDefault();
            });

            resyncButton.addEventListener('click', function(event) {
                let ticket_id = $(this).closest('.modal').data('ticket_id');
                let url = urls['csat:resync-review'](ticket_id);
                resyncButton.classList.add('loading');
                resyncButton.classList.add('no-click');
                resyncText.innerText = "Fetching ticket details. Please wait...";

                $.post(url).done(function (data) {
                    let taskId = data.task_id;
                    let taskUrl = urls['task_check'](taskId);

                    dataTimeManager.start();

                    let taskCheck = async () => {
                        await fetch(taskUrl, {
                            method: "GET",
                        })
                        .then(response => response.json())
                        .then((taskData) => {
                            if(taskData.done) {
                                dataTimeManager.abort();
                                resyncButton.classList.add('hide');
                                resyncMessaging.classList.remove('hide');

                                let successMessage = `
                                        Successfully synced ticket details. 
                                        <a class="refresh-link">Click here to refresh</a>.
                                    `;

                                let failMessage = `
                                        We weren't able to fetch ticket details. Please ensure this
                                        ticket exists in your PSA, and check your API permissions.
                                    `;

                                if(taskData.successful && (taskData.response === null || taskData.response.fetched)) {
                                    resyncMessaging.innerHTML = successMessage;

                                    document.querySelector('.refresh-link').addEventListener('click', () => {
                                        window.location.reload();
                                    });
                                } else {
                                    resyncMessaging.classList.add("error");
                                    resyncMessaging.innerHTML = failMessage
                                }
                            }
                        })        
                    };

                    dataTimeManager.interval(taskCheck);
                });
                event.preventDefault();
            });

            $('.reactions-modal-detailsTable-row .edit-button').on('click', function (e) {
                $(this).parents('.reactions-modal-detailsTable-row').addClass('editing');
                e.preventDefault();
                return false;
            });
            $('#reactions-details-agents-edit').on('keyup', function (e) {
                window.table.validateResources();
                if (e.keyCode == 13) {
                    $('.reactions-modal-detailsTable-row .accept-changes').click();
                }
            });
            $('.reactions-modal-detailsTable-row .accept-changes').on('click', function (e) {
                e.preventDefault();

                if (window.table.validateResources() === false) {
                    $('#reaction-details-agents-errorMessage').append("<span>Resources have not been saved!</span>");
                    return false;
                }

                $(this).parents('.reactions-modal-detailsTable-row').removeClass('editing');
                let ticket_id = window.table.reactionDialog.data('ticket_id');
                let agents = $('#reactions-details-agents-edit').val();

                // report new status to the backend
                window.table.triggerAction(ticket_id, 'RESOURCES_CHANGED', {'resources': agents});

                // update status in the datatable
                let currentRow = window.table.getCurrentRow();
                currentRow.data().agents = utilities.sanitizeData(agents);
                currentRow.invalidate();

                onUpdate({'agents':agents});

                // trigger the 'createdRow' callback again to update CSS classes and child node
                window.table.createRowCallback(currentRow.node(), currentRow.data(), currentRow.index());

                $('.reaction-details-agents .value').text(agents.join(', '));
                return false;
            });
            $('.reactions-modal-detailsTable-row .cancel').on('click', function (e) {
                $(this).parents('.reactions-modal-detailsTable-row').removeClass('editing');
                e.preventDefault();
                return false;
            });
            $('#reaction-details-note-save').click(function (event) {
                let ticket_id = window.table.reactionDialog.data('ticket_id');
                let note = $('#reaction-details-note').val();
                if (window.table.validateNote(note)) {
                    // report new status to the backend
                    window.table.triggerAction(ticket_id, 'NOTE_ADDED', {'note': note});

                    // clear the field for the next note entry
                    $('#reaction-details-note').val('').css('height', '28px');
                }

                event.preventDefault();
            });
        }

        if(globals.user_authorization.csat_admin) {
            $('.change-type-dropdown a').on('click', function (event) {
                let ticket_id = window.table.reactionDialog.data('ticket_id');
                let newValue = parseInt($(this).attr('data-sentiment-type'));

                $('.modal-body').removeClass('csat-reaction-type-positive csat-reaction-type-neutral csat-reaction-type-negative');
                var css_class = 'csat-reaction-type-' + globals.getSentimentLabel(newValue);
                $('.modal-body').addClass(css_class);
                $('#show-reaction-details .reaction-details-type div img').attr('src', globals.getSentimentImageUrl(newValue));

                // report new sentiment to the backend
                window.table.triggerAction(ticket_id, 'SENTIMENT_CHANGED', {'sentiment': newValue});

                // update sentiment in the datatable
                let currentRow = window.table.getCurrentRow();
                currentRow.data().sentiment = newValue;
                currentRow.invalidate();

                // update the dialog
                window.table.populateReactionDetailsDialog(currentRow.data());

                // trigger the 'createdRow' callback again to update CSS classes and child node
                window.table.createRowCallback(currentRow.node(), currentRow.data(), currentRow.index());

                // This is just to run the stats recalculation! The row itself has already redrawn due to the invalidate() call above.
                window.table.reactions.draw('full-hold');

                event.preventDefault();
                return true;
            });
            $('#reaction-details-button-exclude').confirmation(
                {
                    rootSelector: '[data-toggle=confirmation]',
                    placement: 'right',
                    singleton: true,
                    popout: true,
                    btnOkLabel: 'Delete',
                    btnOkIcon: null,
                    btnCancelIcon: null,
                    onConfirm: function () {
                        window.table.changeReactionStatus('deleted');
                    }
                }
            );
        }   // if(globals.user_authorization.csat_admin)

    }

    downloadCSV(type) {
        let params = {};
        if (type == 'filters') {
            params = JSON.parse(this.reactions.ajax.params());
            params['start'] = 0;
            delete params['length'];
        }else if (type == 'deleted') {
            params['filters'] = {'statuses': ['deleted']};
        }
        $.ajax({
            url: urls['csat:csv-export-reactions-table'](),
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(params)
        }).done((data, status, jqxhr) => {
            let blob = new Blob([data], {type: 'text/csv'});
            let filename = jqxhr.getResponseHeader('filename');
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            }
        });
    }

    resizeHandler() {
        let comments = $('.csat-reaction-child-comment p');
        comments.each(function () {
            let btn = $(this).parent().parent().find('.less-more');
            if (this.scrollWidth > this.offsetWidth){
                btn.show();
            } else if ($(this).css('white-space') != 'normal'){
                btn.hide();
            }
        });
    }

    triggerAction(ticket_id, action, data, callback) {
        let payload = $.extend({'action': action}, data);
        // sanitize for xss
        if(payload.action === "RESOURCES_CHANGED") {
            payload.resources.forEach((resource, i) => {
                payload.resources[i] = resource;
            })
        }

        if(payload.action === "TAGS_CHANGED") {
            payload.tags.forEach((tag, i) => {
                payload.tags[i] = utilities.sanitizeData(tag);
            })
        }

        if(payload.action === "NOTE_ADDED") {
            payload.note = utilities.sanitizeData(payload.note);
        }

        $.ajax({
            type: 'POST',
            url: urls['csat:modify-review'](ticket_id),
            data: JSON.stringify(payload),
            success: (data) => {
                this.displayActivityStream(ticket_id, data);
                if(callback) {
                    callback();
                }
            }
        });
    }
    getCurrentRow() {
        let rowId = this.reactionDialog.data('row-id');
        return this.reactions.row('#'+rowId);
    }
    
    changeReactionStatus(newStatus) {
        let ticket_id = this.reactionDialog.data('ticket_id');

        let triggerCallback = () => {
            // update status in the datatable
            let currentRow = this.getCurrentRow();

            if (newStatus == 'deleted') {
                currentRow.remove().draw(false);
                this.reactionDialog.modal('hide');

            } else {
                if(currentRow.data()){
                    currentRow.data().status = newStatus;
                    currentRow.invalidate();

                    // trigger the 'createdRow' callback again to update CSS classes and child node
                    this.createRowCallback(currentRow.node(), currentRow.data(), currentRow.index());

                    // update the dialog
                    this.populateReactionDetailsDialog(currentRow.data());
                } else {
                    if(newStatus === 'open' || newStatus === 'done') {
                        $('#reaction-details-button-done').toggle();
                        $('#reaction-details-button-open').toggle();
                    }
                }

                // redraw the table, which should rerun all filters and stats calculations
                this.reactions.draw('full-hold');
            }
        }

        // report new status to the backend
        this.triggerAction(ticket_id, 'STATUS_CHANGED', {'status': newStatus}, triggerCallback);

    }
    updateDocumentTitle(ticketId) {
        if (ticketId) {
            let newTitle = 'Review of Ticket #' + ticketId + ' \u2013 SmileBack';
            if (!window.initialTitle) {
                window.initialTitle = document.title;
            }
            document.title = newTitle.replace('<','&lt;').replace('>','&gt;').replace(' & ',' &amp; ');
        } else if (window.initialTitle) {
            document.title = window.initialTitle;
        }
    }
    showReactionDetails(rowId) {
        resyncButton.classList.remove('hide');
        resyncText.innerText = resyncText.dataset.original;
        resyncMessaging.classList.remove("error");
        resyncMessaging.classList.add('hide');
        resyncButton.classList.remove('loading');
        resyncButton.classList.remove('no-click');

        let data = this.reactions.row('#'+rowId).data();
        if (data) {
            let ticketWasLoaded = (data.ticket.title !== null);
            this.reactionDialog.data('ticket_id', data.ticket.id)
                    .data('row-id', rowId)
                    .toggleClass('error', !ticketWasLoaded);

            this.populateReactionDetailsDialog(data);

            if (ticketWasLoaded) {
                this.loadActivityStream(data.ticket.id, false);
            }

            this.togglereactionDialog('show');
        }
    }
    capitalizeFirstLetter(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }

    populateReactionDetailsDialog(data) {
        if(columnConfig.session) {
            $(".reactions-modal-detailsTable-label.ticket span").text("Session");
        }

        if(data.labels) {
            let labels = typeof data.labels === 'string' ? JSON.parse(data.labels.replace(/'/g, '"')) : data.labels;

            let additionalDetails = document.querySelector(".reactions-modal-detailsTable-value.additional-details");
            let renderedDetails = '';

            labels.forEach(detail => {
                if(detail.value) {
                    renderedDetails += `
                        <div class="detail-row">
                            <div class="label">${detail.name}</div>
                            <div class="value">${detail.value}</div>
                        </div>
                    `;
                }
            })

            if(additionalDetails) {
                additionalDetails.innerHTML = renderedDetails || "-";
                document.querySelector('.additional-details-wrapper').classList.remove("hide");
            }
        }

        $('#reaction-details-tags-errorMessage').html('');
        $('.reaction-details-ticket-id').text(data.ticket.id).attr('href', data.ticket.link);
        $('.reaction-details-ticket-summary').html(data.ticket.title || '?');
        $('.reaction-details-status').html(this.capitalizeFirstLetter(data.status));
        $('.reaction-details-type div').html($('<img>', {'src': globals.getSentimentImageUrl(data.sentiment), 'alt': globals.getSentimentLabel(data.sentiment)}));
        $('.reaction-details-date span:first').html(data.timestamp.formatted);
        $('.has-marketing-permission').text(data.publicize ? "Yes" : "No");
        $('.reaction-details-comment').html((data.comment !== undefined && data.comment.length > 0)?'<p class="mb-0">'+data.comment+'</p>':'');
        $('#reaction-details-button-done').toggle(data.status == 'open');
        $('#reaction-details-button-open').toggle(data.status == 'done');
        $('.reaction-details-market').html(data.company.market_name === "None" ? '-' : data.company.market_name || '-');
        $('.reaction-details-territory').html(data.company.territory_name === "None" ? '-' : data.company.territory_name || '-');
        $('.reaction-details-groups').html(!data.groups || !data.groups.length ? '-' : data.groups.join(', ') || '-');
        
        if(data.publicize) {
            let toggle = `<div class="mini-toggle">
                            <input 
                                type="checkbox" 
                                id="review-modal-${data.ticket.id}" 
                                class="permissions-toggle ${this.isCsatAdmin ? '' : 'disabled'}" 
                                data-ticket-id='${data.ticket.id}' 
                                onclick='window.table.togglePublish(event)' 
                                ${data.widget_publicize ? 'checked' : ''}>
                            </input>
                            <label for="review-modal-${data.ticket.id}"></label>
                        </div>`;
 
            $('.publish-comment').html(toggle);
        } else {
            if(data.comment !== undefined && data.comment.length > 0) {
                $('.publish-comment').text("Marketing permission not provided");
            } else {
                $('.publish-comment').text("Comment not provided");
            }
        }

        if (!this.reactionDialog.hasClass('error')) {
            $('.reactions-modal-activities').attr('data-id', data.ticket.id);
            data.contact.name ? $('.reaction-details-contact').html(data.contact.name) : $('.reaction-details-contact').parent().hide();
            data.company.name ? $('.reaction-details-company').html(data.company.name) : $('.reaction-details-company').parent().hide();
            data.segment ? $('.reaction-details-segment').html(data.segment) : $('.reaction-details-segment').parent().hide();

            if(this.reactionDetailsTagsWidget) {
                let tags = [];
                data.tags.forEach(tag => tags.push(this.htmlDecode(tag)));
                this.reactionDetailsTagsWidget.setValue(tags);
            }
            let agents = [];
            data.agents.forEach(agent => agents.push(this.htmlDecode(agent)));
            this.reactionDetailsAgentsWidget.setValue(agents);
            $('.reaction-details-agents .value').text(agents.join(', '));
        }
        autosize($('#reaction-details-note'));

        // Update css class for sentiment type.
        // but reset css classes first.
        $('.modal-body').removeClass('csat-reaction-type-positive csat-reaction-type-neutral csat-reaction-type-negative');
        var css_class = 'csat-reaction-type-'+globals.getSentimentLabel(data.sentiment);
        $('.modal-body').addClass(css_class);
    }
    togglereactionDialog(action) {
        if (this.isCurrentlyPopstating) {
            this.reactionDialog.removeClass('fade').modal(action).addClass('fade');
        } else {
            this.reactionDialog.modal(action);
        }
    }
    
    htmlDecode(input) {
        var txt = document.createElement("textarea");
        txt.innerHTML = input;
        return txt.value;
    }

    createRowCallback(row, data, dataIndex) {
        var rowTr = $(row);
        var rowObj = this.reactions.row(dataIndex); 

        // create a new child row, attach it to this parent row, and show it immediately
        rowObj.child(this.childRowFormat(data)).show();

        // assign a CSS class to each row, based on the status
        rowTr.toggleClass('status-open', data.status == 'open')
             .toggleClass('status-done', data.status == 'done');
        rowTr.toggleClass('sentiment-type-positive', data.sentiment == +1)
             .toggleClass('sentiment-type-neutral', data.sentiment == 0)
             .toggleClass('sentiment-type-negative', data.sentiment == -1)

        rowTr.attr('role', 'row');
    }
    getTicketId() {
        let result = window.location.pathname.match(TICKET_ID_REGEX);
        return result ? result[1] : null;
    }
    childRowFormat(data) {
        var reaction_class = 'undefined';
        if (data.sentiment == 1) {
            reaction_class = 'csat-reaction-type-positive';
        } else if (data.sentiment == 0) {
            reaction_class = 'csat-reaction-type-neutral';
        } else if (data.sentiment == -1) {
            reaction_class = 'csat-reaction-type-negative';
        }

        var comment = data.comment ? ('<div class="csat-reaction-child-comment"><p>' + data.comment + '</p></div><a href="#" class="ml-2 less-more">more</a>') : '';
        var tags = data.tags.length > 0 ? ('<div class="csat-reaction-child-tags"><b>Tags:</b> ' + data.tags.join(', ') + '</div>') : '';
        return `<div class="csat-reaction-child ${reaction_class}">
                    ${comment} ${tags}
                </div>`;
    }
    togglePublish(event) {

        if(!this.isCsatAdmin) return;

        anim.start();

        let ticketID = event.target.getAttribute("data-ticket-id");
        let publish = event.target.checked ? 1 : 0;

        // this.reactions.cell(row, col).data(event.target.checked ? true : false);

        $.ajax({
            type: 'POST',
            url: urls['csat:publish_comment'](ticketID),
            data: {
                publish
            }
        }).done(() => {
            anim.complete();
        });
    }


    loadActivityStream (ticket_id, keepValues) {
        if ($('.reactions-modal-activities h4 .loading-indicator').length === 0) {
            $('.reactions-modal-activities h4').append('<span class="loading-indicator"></span>');
        }
        if (keepValues) {
            $('.reactions-modal-activities').css('min-height', $('.reactions-modal-activities').height());
        } else {
            $('.reactions-modal-activities').css('min-height', 0);
            $('#reaction-details-activity-stream').html('');
        }

        var url = urls['csat:review-activity'](ticket_id);
        $.get(url, (html) => {
          this.displayActivityStream(ticket_id, html);
        });
    }
    displayActivityStream(ticket_id, streamData) {
        if ($('.reactions-modal-activities').attr('data-id') == ticket_id) {
          var previous_items = $('#reaction-details-activity-stream').html();
          var current_amount_of_items = $('.reactions-modal-activity-details',$("<div>"+previous_items+"</div>")).length;
          var coming_amount_of_items = $('.reactions-modal-activity-details',$("<div>"+streamData+"</div>")).length;
          $('#reaction-details-activity-stream').html(streamData);
          var new_items = coming_amount_of_items - current_amount_of_items;
          if (current_amount_of_items > 0 && new_items > 0){
            setTimeout(function(){
              $('#reaction-details-activity-stream .reactions-modal-activity-details').slice(0, new_items).addClass('highlight-animated');
            },100);
          }

          $('.reactions-modal-activities h4 .loading-indicator').remove();
        }
        $('.reactions-modal-activities').css('min-height', 0);

        this.updateActivityStreamOptions();
    }
    updateActivityStreamOptions() {
      var item_amount = $('.reactions-modal-activities .reactions-modal-activity-details').length;
      if (item_amount > 10) {
        $('.activity-more-amount').text(item_amount - 10);
        $('.reactions-modal-activities').addClass('has-more-options');
      }else {
        $('.reactions-modal-activities').removeClass('has-more-options');
      }
    }
    validateResources() {
        let errorMessages = $('#reaction-details-agents-errorMessage');
        let agents = $('#reactions-details-agents-edit').val();
        errorMessages.html("");

        var RESOURCES_LIMIT = 2000;
        if (agents.length > RESOURCES_LIMIT) {
            errorMessages.append("<span>Resources are limited to " + RESOURCES_LIMIT + " characters. Currently it's " + agents.length + " characters long.");
            return false;
        }
        return true;
    }
    validateNote(note) {
        let errorMessage = $('#reaction-details-note-errorMessage');
        let NOTES_LIMIT = 2000;
        if (note.length > NOTES_LIMIT) {
            errorMessage.html('<span>Notes are limited to ' + NOTES_LIMIT + ' characters. Currently, this note is ' + note.length + ' characters long.');
            return false;
        } else {
            errorMessage.html('');
            return true;
        }
    }
    validateTags() {
        let tags = this.reactionDetailsTagsWidget.getValue();
        let errorMessages = $('#reaction-details-tags-errorMessage');
        errorMessages.html("");

        if (tags) {
            let LIMIT_TAGS = 20;
            if (tags.length > LIMIT_TAGS) {
                errorMessages.append('<span>Tags are limited to ' + LIMIT_TAGS + ' tags per review. You currently have ' + tags.length + ' tags.</span>');
            }

            let LIMIT_TAG_LENGTH = 50;
            $.each(tags, function (i, tag) {
                if (tag.length > LIMIT_TAG_LENGTH) {
                    errorMessages.append("<span>Tags are limited to " + LIMIT_TAG_LENGTH + " characters per tag. '" + tag.substr(0, 10) + "...' is " + tag.length + " characters long.</span>");
                }
            });
        }
        return errorMessages.children().length === 0;
    }
    update(data)  {
        filterData = data;
        this.reactions.draw();
    }
}

export default ReviewsTable;
